import { useMutation, useQuery } from "@tanstack/react-query"
import instancePos from "../api/apiV2"
import instanceCB from "../api/cbApi";
import { toast } from "react-toastify";
import { queryClient } from "../../App";

export const useGetRestaurantsCategoriesDetails = () => {
    return useQuery({
        queryKey: ['restaurants-categories-details'],
        queryFn: async () => {
            let response = await instancePos.get(`/restaurant-active-inactive-category-detail`);

            return response?.data?.data || {}
        },
    })
}

export const useGetCategoryDetails = (restaurant_id) => {
    return useQuery({
        queryKey: ['restaurant-category-detail', restaurant_id],
        queryFn: async () => {
            let response = await instancePos.post(`/restaurant-category-detail`, {
                restaurant_id: restaurant_id
            });
            return response?.data?.data || {}
        }
    })
}


export const useEnableCategories = () => {
    return useMutation(
        {
            mutationFn: async ({ restaurant_id, category_ids }) => {
                let response = await instancePos.post(`/enable-restaurant-categories`, {
                    restaurant_id,
                    category_ids
                });
                return response?.data
            },
            meta:{
                successMsg:true,
                errorMsg:true
            }
        }
    )
}

export const useDisableCategories = () => {
    return useMutation(
        {
            mutationFn: async ({ restaurant_id, category_ids }) => {
                let response = await instancePos.post(`/disables-restaurant-categories`, {
                    restaurant_id,
                    category_ids
                });
                return response?.data
            },
            meta: {
                successMsg: true,
                errorMsg: true
            }
        }
    )
}

export const useGetCrunchMapping = (restaurant_id) => {
    return useQuery({
        queryKey: ["crunch-mapping", restaurant_id],
        queryFn: async () => {
            const response = await instanceCB.get('/backend/categories/crunch-mapping?include-name=true',
                {
                    headers: {
                        restaurant_id: restaurant_id,
                    },
                }
            );
            return response?.data?.data || {};
        },
    });
};


export const useDeleteCrunchMapping = () => {
    return useMutation({
        mutationFn: async ({ restaurant_id, crunchCategoryId, mappedId }) => {
            const response = await instanceCB.delete('/backend/categories/crunch-mapping',
                {
                    data: {
                        crunchCategoryId,
                    },
                    headers: {
                        restaurant_id: restaurant_id,
                    },
                    withCredentials: true, // 🔑 allows sending cookies
                }
            );
            return response?.data || {};
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["restaurant-category-detail"] })
            toast.success(data?.message)
        },
        onError: (data) => {

            toast.error(data?.response?.data?.message)
        },
        meta: {
            successMsg: true,
            errorMsg: true
        }
    })
}

export const useClickbaconCoA = (restaurant_id) => {
    return useQuery({
        queryKey: ['cb-coa', restaurant_id],
        queryFn: async () => {
            let response = await instanceCB.post(`/backend/utils/categories`,
                {
                    restaurantId: restaurant_id,
                },

            );
            return response?.data || {};
        },
    });
};


export const useAddCrunchMapping = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const response = await instanceCB.post('/backend/categories/crunch-mapping', payload,{
                headers:{
                    restaurant_id: payload?.restaurant_id
                }
            });
            return response?.data || {};
        },
        meta: {
            successMsg: true,
            errorMsg: true
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["restaurant-category-detail"] })
            toast.success(data?.message)
        },
        onError: (data) => {
            toast.error(data?.response?.data?.message)
        }
    })
}


export const useAddNewCustomCategory=()=>{
    return useMutation({
        mutationFn:async(payload)=>{
            let response=await instancePos.post('/custom-categories',payload);
            return response?.data || {};
        },
        meta: {
            successMsg: true,
            errorMsg: true
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["restaurant-category-detail"] })
            toast.success(data?.message)
        },
        onError: (data) => {
            toast.error(data?.response?.data?.message)
        }
    })
};
